const transformPayload = payload =>
    Object.entries(payload).map(([questionId, answer]) => ({ questionId, answer }));

const updateSurveyMutation = payload => {
    const transformedPayload = transformPayload(payload);
    const responses = transformedPayload
        .map(({ questionId, answer }) => `{ questionId: "${questionId}", answer: "${answer}" }`)
        .join(', ');

    return `
        mutation {
            updateSurvey(surveyResponses: [${responses}]) {
                errors
                isSurveyCompleted
            }
        }
    `;
};

const fetchIsSurveyCompletedQuery = () => {
    return `
    query {
        isSurveyCompleted
        surveyQuestions
    }`;
};

export {
    updateSurveyMutation,
    fetchIsSurveyCompletedQuery
};
